import { AfterViewInit, Directive, ElementRef, HostListener, Input, inject } from '@angular/core';

@Directive({ selector: '[appDnDistEdit]' })
export class DnDistEditDirective implements AfterViewInit {
  private el = inject(ElementRef);

  @Input() row: any;
  @Input() previousValue: any;
  @Input() stopEdit!: () => void;
  @Input() cancelEdit!: (row: any, col: string) => void;

  ngAfterViewInit() {
    const matSelect: HTMLElement | null =
      this.el.nativeElement.querySelector('mat-select');
    const input: HTMLInputElement | null =
      this.el.nativeElement.querySelector('input');

    // ouvrir le select en arrière-plan
    if (matSelect) {
      setTimeout(() => matSelect.click());
    }

    // mais mettre le focus direct sur l’input distance
    if (input) {
      setTimeout(() => input.focus(), 0);
    }
  }

  // ESC → rollback
  @HostListener('document:keydown.escape', ['$event'])
  handleEscape(event: Event) {
    event.preventDefault();
    if (this.cancelEdit) {
      this.row.down = this.previousValue?.down;
      this.row.distance = this.previousValue?.distance;
      this.cancelEdit(this.row, 'dnDist');
    }
  }

  // clic extérieur → save and close
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    if (!this.el.nativeElement.contains(event.target)) {
      this.stopEdit();
    }
  }
}
